import React from "react";
import { CircularProgress } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { translate } from "../../../../common/providers";
import styles from "./AddConsortiumDialog.module.css";
import { CustomTextField, icon, IconComponent } from "../../../../common/components";

const AutoCompleteSearch = ({ users, searchUser, handleSelectUser, isLoadingUsers, error, label, placeholder }) => {
	const filterOptions = createFilterOptions({
		stringify: (option) => `${option.displayName} ${option.email}`,
	});
	return (
		<Autocomplete
			disableClearable
			fullWidth
			classes={{ listbox: styles.options, option: styles.option, paper: styles.options__paper }}
			className={styles.autoCompleteSearch}
			filterOptions={filterOptions}
			getOptionLabel={(option) => option.displayName}
			loading={isLoadingUsers}
			options={users}
			popupIcon={<IconComponent color="var(--icon-secondary)" icon={icon.faChevronDown} size="xs" />}
			renderInput={(params) => (
				<CustomTextField
					{...params}
					error={error}
					helperText={error && translate("common:error.required")}
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<>
								{isLoadingUsers ? <CircularProgress size={20} /> : null}
								{params.InputProps.endAdornment}
							</>
						),
					}}
					label={label}
					placeholder={placeholder}
					variant="outlined"
				/>
			)}
			renderOption={(props, option) => (
				<li {...props}>
					<span className={styles.option__name}>{option.displayName}</span>
					<span className={styles.option__email}>{option.email}</span>
				</li>
			)}
			onChange={(e, value) => {
				handleSelectUser(value);
			}}
			onInputChange={(e) => {
				searchUser(e);
			}}
		/>
	);
};
export default AutoCompleteSearch;
